import { Routes } from '@angular/router';
import { MerakiGoProvisioningComponent } from '@app/features/merakis/modules/meraki-go-provisioning/components/meraki-go-provisioning/meraki-go-provisioning.component';
import { Authority } from '@app/shared/utils/enums';

export const merakiGoProvisioningRoutes: Routes = [
    {
        path: 'meraki-go-provisioning',
        children: [
            {
                path: '',
                component: MerakiGoProvisioningComponent,
                data: {
                    authorities: [Authority.ADMIN]
                }
                //,canActivate: [RouteAccessGuard]
            }
        ]
    }
]